import { render, staticRenderFns } from "./AlertPersonalSet.vue?vue&type=template&id=a23fe924&scoped=true"
import script from "./AlertPersonalSet.vue?vue&type=script&lang=js"
export * from "./AlertPersonalSet.vue?vue&type=script&lang=js"
import style0 from "./AlertPersonalSet.vue?vue&type=style&index=0&id=a23fe924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23fe924",
  null
  
)

export default component.exports